/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GetTutorialResponseAllOf,
    GetTutorialResponseAllOfFromJSON,
    GetTutorialResponseAllOfFromJSONTyped,
    GetTutorialResponseAllOfToJSON,
} from './GetTutorialResponseAllOf';
import {
    GetTutorialResponseAllOfData,
    GetTutorialResponseAllOfDataFromJSON,
    GetTutorialResponseAllOfDataFromJSONTyped,
    GetTutorialResponseAllOfDataToJSON,
} from './GetTutorialResponseAllOfData';
import {
    MediaUserApiResponse,
    MediaUserApiResponseFromJSON,
    MediaUserApiResponseFromJSONTyped,
    MediaUserApiResponseToJSON,
} from './MediaUserApiResponse';

/**
 * 
 * @export
 * @interface GetTutorialResponse
 */
export interface GetTutorialResponse {
    /**
     * ステータスコード
     * @type {number}
     * @memberof GetTutorialResponse
     */
    status: number;
    /**
     * ステータスメッセージ
     * @type {string}
     * @memberof GetTutorialResponse
     */
    message: string;
    /**
     * 
     * @type {GetTutorialResponseAllOfData}
     * @memberof GetTutorialResponse
     */
    data: GetTutorialResponseAllOfData;
}

export function GetTutorialResponseFromJSON(json: any): GetTutorialResponse {
    return GetTutorialResponseFromJSONTyped(json, false);
}

export function GetTutorialResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTutorialResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': GetTutorialResponseAllOfDataFromJSON(json['data']),
    };
}

export function GetTutorialResponseToJSON(value?: GetTutorialResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': GetTutorialResponseAllOfDataToJSON(value.data),
    };
}

